export default __webpack_public_path__ + "static/media/WatersEdgeMap.446ed850.jpg";